var App = App || {};

App.SiteSearch = (function ($) {
    "use strict";

    function init() {

        const bpsDesktop = ["xxl", "xl", "lg"];
        const offcanvas = $("#SiteSearch");
        const setHeight = offcanvas.find(".site-search-form-content");
        const searchField = offcanvas.find("form").find(".form-control");
        const popular = offcanvas.find(".site-search-popular");

        offcanvas.on("show.bs.offcanvas", function () {
            searchField.on("focus", function () {
                if (bpsDesktop.includes(ZAGFramework.GetCurrentBP())) {
                    popular.slideDown(200);
                }
            });

            searchField.on("blur", function () {
                if (bpsDesktop.includes(ZAGFramework.GetCurrentBP() && $(this).val() == "")) {
                    popular.slideUp(200);
                }
            });

            if (bpsDesktop.includes(ZAGFramework.GetCurrentBP())) {
                setHeight.height($(".site-header").outerHeight());
            }
        });

        offcanvas.on("hidden.bs.offcanvas", function () {
            setHeight.removeAttr("style");
        });



    }

    return {
        init, init
    };

})(jQuery);

$(function () {
    App.SiteSearch.init();
});